<template>
    <div class="bawah">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-4">
                    <div class="logo">
                        <img :src="logo">
                    </div>
                </div>
                <div class="col-12 col-lg-4">
                    <div class="navbar-link">
                        <router-link to="/" class="nav-link">Home</router-link>
                        <router-link to="/about" class="nav-link">About</router-link>
                        <router-link to="/project" class="nav-link">Project</router-link>
                    </div>
                </div>
                <div class="col-12 col-lg-4">
                    <div class="social">
                        <a href="#" style="text-decoration:none;"><img :src="social1" ></a>
                        <a href="#" style="text-decoration:none;"><img :src="social2" ></a>
                        <a href="#" style="text-decoration:none;"><img :src="social3" ></a>
                    </div>
                </div>
            </div>
            <div class="footer">
                Copright &copy; 2020 - {{currentYear}} | {{made}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data (){
            return{
                    logo : require('../assets/logo.png'),
                    social1 :'https://img.icons8.com/material-outlined/24/FFD60A/instagram-new--v1.png',
                    social2 :'https://img.icons8.com/windows/32/FFD60A/behance.png',
                    social3 :'https://img.icons8.com/material-outlined/24/FFD60A/whatsapp--v1.png',
                    currentYear : new Date(). getFullYear(),
                    made : 'JXB Creative'
            }
        }
    }
</script>

<style scoped>
    .bawah {
        margin-top: 50px;
        margin-bottom: 20px;
    }
    .nav-link{
        color: #ffff;
        font-size: .9rem;
    }
    .nav-link:hover{
        color: #ffd60a;
    }
    .footer{
        margin-top: 40px;
        text-align: center;
        font-size: .9rem;
        color: #a4a4a4;
    }

     /* Large Desktop */
    @media(min-width: 1200px){
        .logo{
            text-align: left;
        }
        .navbar-link{
            justify-content: center;
            display: flex;
            margin-top: 5px;
        }
        .nav-link{
            margin:0 15px;
        }
        .social{
            text-align: center;
        }
        .social img{
            margin: 0 10px;
        }
    }
    /* Middle Desktop */
    @media(min-width: 1025px) and (max-width: 1199px){
        .logo{
            text-align: left;
        }
        .navbar-link{
            justify-content: center;
            display: flex;
            margin-top: 5px;
        }
        .nav-link{
            margin:0 15px;
        }
        .social{
            text-align: center;
        }
        .social img{
            margin: 0 10px;
        }
    }
    /* Desktop */
    @media(min-width: 992px) and (max-width: 1024px){
        .logo{
            text-align: left;
        }
        .navbar-link{
            justify-content: center;
            display: flex;
            margin-top: 5px;
        }
        .nav-link{
            margin:0 15px;
        }
        .social{
            text-align: center;
        }
        .social img{
            margin: 0 10px;
        }
    }
    /* Tablet */
    @media(min-width: 768px) and (max-width: 991px){
       .logo{
            text-align: center;
        }
        .navbar-link{
            display: flex;
            justify-content: center;
            margin-top: 20px;
        }
        .nav-link{
            margin:20px 15px;
        }
        .social{
            text-align: center;
        }
        .social img{
            margin: 0 10px;
        }
    }
    /* Handphone */
    @media(max-width: 767px){
        .logo{
            text-align: center;
        }
        .navbar-link{
            justify-content: center;
            display: flex;
            margin-top: 20px;
        }
        .nav-link{
            margin:20px 15px;
        }
        .social{
            text-align: center;
        }
        .social img{
            margin: 0 10px;
        }
    }
</style>